// 'use strict';
// exports.type = 'factory';
// exports.name = 'MintdataSubscriber';
// exports.func = ['AuthenticationService', 'FeaturesService', function (AuthenticationService, FeaturesService)

export class EventSourceSubscriber
{
    private _isFunction(functionToCheck: any)
    {
        var getType = {};
        return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
    }

    constructor(url: any, options: any)
    {
        const subdomains = []; //FeaturesService.getAsList('sse.subdomains');

        // if (subdomains && subdomains.length > 0) {
        //     var randomSubdomain = subdomains[Math.floor(Math.random() * subdomains.length)];
        //     if (randomSubdomain.length > 0) {
        //         var index = url.indexOf('://');
        //         if (index != -1) {
        //             var newUrl = url.substring(0, index + 3) + randomSubdomain + '.' + url.substring(index + 3);
        //             url = newUrl;
        //         }
        //     }
        // }

        const opts =
            {
                onmessage: function ()
                {
                },
                onclose: function ()
                {
                },
                // TODO: add auth
                // query: $.extend(options.query, AuthenticationService.getAuthenticationParam())
            } as any;

        if (this._isFunction(options.onmessage))
            opts.onmessage = options.onmessage;

        if (this._isFunction(options.onclose))
            opts.onclose = options.onclose;

        // if (url.indexOf('?') == -1)
        //     url = url + "?" + opts.query.join("&"); //$.param(opts.query);
        // else
        //     url = url + "&" + opts.query.join("&"); //$.param(opts.query);

        // var fullUrl = url;

        var source = new (window as any).EventSource(url);

        source.onmessage = function (ev: any) {
            var id = ev.lastEventId;
            if (id == "data")
                opts.onmessage(ev.data);
        };

        source.onclose = function (ev: any) {
            console.log('EventSource has been closed: ', url, ev);
            opts.onclose(ev);
        };

        source.onerror = function (ev: any) {
            console.log('EventSource has received an error: ', url, ev);
            source.close();
        };

        source.onopen = function (ev: any) {
            console.log('EventSource has been opened: ', url, ev);
        };

        (this as any).close = function (ev: any) {
            console.log('EventSource has been closed: ', url, ev);
            source.close();
        };
    }
}